import { useQuery } from '@tanstack/react-query';
import { boardApi } from '../services/taskApi';
import { BoardSummary, ListItemsParams } from '../types';

export const BOARD_SUMMARIES_QUERY_KEY = 'board-summaries';

export function useBoardSummaries(
  params: {
    workspace_id?: string;
    board_ids?: string[];
    show_completed?: boolean;
  } & ListItemsParams,
  options?: { enabled?: boolean }
) {
  return useQuery<Record<string, BoardSummary>>({
    queryKey: [BOARD_SUMMARIES_QUERY_KEY, params],
    queryFn: () => boardApi.getBoardSummaries(params),
    enabled: options?.enabled ?? true,
  });
}
